/* eslint-disable max-len */
import { defineMessages, useIntl } from 'react-intl';
import { View } from '@carbon/icons-react';
import { useNavigate } from 'react-router-dom';

import CommonButton from 'Components/Common/CommonButton/CommonButton';

type Props = {
    id: string;
    onViewDetails?: (id: string) => void;
}

const ViewTeamMemberButton = ({
    id,
    onViewDetails,
}: Props) => {
    const intl = useIntl();
    const navigate = useNavigate();

    const onOpenRequest = () => {
        if (onViewDetails) {
            onViewDetails(id);
            return;
        }

        navigate(id);
    };

    return (
        <CommonButton
            align="bottom"
            label={intl.formatMessage(messages.editMember)}
            kind="ghost"
            iconSize={21}
            icon={<View />}
            onClick={onOpenRequest}
        />
    );
};

const messages = defineMessages({
    editMember: {
        id: 'src.Screens.Dashboard.Team.Components.TeamCellHandler.TeamInteractions.Interactions.Details.ViewTeamMemberDetails.ViewTeamMemberDetails.editMember',
        defaultMessage: 'Zobacz dane tej osoby',
    },
});

export default ViewTeamMemberButton;
